import React from "react";
import { createRoot } from "react-dom/client";
import VoiceChess from "../components/voicechess/VoiceChess.jsx";

const root = createRoot(document.getElementById("root"));
root.render(<VoiceChess />);
